export const imageFields = [
    // {
    //   fieldName: "imageId",
    //   fieldTitle: "Image Id",
    //   validationObj: {
    //     required: "Please Enter Image Id",
    //   },
  
    //   fieldType: "text",
    // },
    // {
    //   fieldName: "imageTitle",
    //   fieldTitle: "Image Title",
    //   validationObj: {
    //     required: "Please Enter Image Title",
    //   },
    //   fieldType: "text",
    // },
    
  
    
    {
      fieldName: "imageUpload",
      fieldTitle: "Upload Image",
      fieldType: "upload",
    },
  ];
  
  export const imageTableHeader = [
    {
      id: "imageId",
      numeric: false,
      label: "Image Id",
      disabled: true,
    },
    {
      id: "imageTitle",
      numeric: false,
      label: "Image Title",
      disabled: true,
    },
    {
        id: "image",
        numeric: false,
        label: "Image",
        disabled: true,
      },
    {
      id: "action",
      numeric: false,
      label: "Actions",
      disabled: true,
    },
  ];
  